import { wrapRootElement as wrapRoot, wrapPageElement as wrapPage } from './wrap-with-provider';

export const wrapRootElement = wrapRoot;
export const wrapPageElement = wrapPage;
